import React, {Component} from "react";

import PropTypes from 'prop-types';
import { generatePath } from "react-router";
import {XLi, XOl, XSpan} from "../Layout/Layout";
import {Link} from "react-router-dom";
import Interface from "../Interface";

class   Breadcrumbs extends Component{

    constructor(props) {
        super(props);

        this.numberKey=0;

        this.routes=[];
        this.cRoutes=[];
        this.param= {};
        this.childs =[];
        this.state = {changed: false};
        this.props=props;
    }

    setRoutes(listRoutes){
        this.routes=listRoutes.map((route, index) => (
            {
                key: route.key,
                parentKey: route.parentKey,
                breadcrumb: route.breadcrumb,
                path: route.path,
            }
        ));
    }

    setCurrent(name){
        this.childs=[];
        this.cRoutes=[];
        this.param= {};
        this.findRoutes(name);
    }

    findRoutes(name) {
        let cRoutes=[];
        while (name !== ""){
            let nameKey=name;
            let obj =  this.routes.find( ( objItem ) => {  return objItem.key === nameKey; } );
            if (obj === undefined) {
                name="";
            }else{
                let copy = Object.assign({}, obj);
                cRoutes.push(copy);
                name=obj.parentKey;
            }
        }
        this.cRoutes = cRoutes.reverse();
    }

    setParameter(name,value) {
        this.param[name]=value;
    }

    setBreadcrumb(name,title) {
        let l=this.cRoutes.length;
        for(let i=0;i<l;i++){
            if(this.cRoutes[i].key===name){
                this.cRoutes[i].breadcrumb=title;
                break;
            }
        }
    }

    insertAfter(name,list) {
        let l=this.cRoutes.length;
        let m;let n;
        for(let i=0;i<l;i++){
            if(this.cRoutes[i].key===name){
                for (m=0;m<list.length;m++){
                    n=i+1+m;
                    this.cRoutes.splice(n, 0, list[m]);
                }
                break;
            }
        }
    }

    show() {
        const len = this.cRoutes.length;
        let param=this.param;
        this.childs=[];
        this.childs=this.cRoutes.map((route, index) => {
            this.numberKey++;
            let el=null;
            if (len === index + 1) {
                el=<XSpan  >{route.breadcrumb}</XSpan>;
            }else{
                if(Interface.isEmptyString(route.path))
                    el=<XSpan  >{route.breadcrumb}</XSpan>;
                else {
                    let p = generatePath(route.path, param);
                    el = <Link to={p}>{route.breadcrumb}</Link>;
                }
            }
            return <XLi className="breadcrumb-item" key={this.numberKey}>{el}</XLi>
        });

        let c=!this.state.changed;
        this.setState({changed: c });
    }

    render() {
        const {
            className,
            id,
        } = this.props;


        return (
            <XOl  id={id} className={`breadcrumb ${className}`}>
                {this.childs}
            </XOl>
        )
    }
}

Breadcrumbs.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
};

Breadcrumbs.defaultProps = {
    className:"",
};

export default Breadcrumbs;
